import React, { PureComponent } from 'react';

const icon = `${process.env.PUBLIC_URL}/img/burger.svg`;

class TopbarSidebarButton extends PureComponent {

  render() {
    const { toggleSidebar } = this.props;

    return (
      <div>
        <button className="topbar__button topbar__button--desktop" type="button" onClick={toggleSidebar}>
          <img src={icon} alt="" className="topbar__button-icon" />
        </button>
      </div>
    );
  }
}

export default TopbarSidebarButton;
